import { api } from "./client";
import type { ClientConfig } from "../types";

export const configApi = {
  getClient: () => api.get<ClientConfig>("/config/client", { skipAuth: true }),
};
